/**
 * Whether the recipe header's actions fit beside the title (found with #794).
 *
 * The wide layout put share, ⋯, « Mode cuisson » and « Planifier » (~410px) in
 * the title's row whenever the WINDOW was 768px or wider. On desktop web the
 * sidebar takes 181px of that window, so at 820px the content column was 640px,
 * the actions took most of it, and the title wrapped one syllable per line —
 * « Broc / hettes / de / tofu ». The actions now sit beside the title only when
 * the content column leaves the title a readable measure, and under it otherwise.
 */

/** Share + ⋯ + two labelled buttons, as measured at 1440px; a slot label is about as wide. */
export const ACTIONS_WIDTH = 420;
/** `blockWide` padding, both sides, and the row gap in RecipeHeader. */
const SIDE_PADDING = 56;
const ROW_GAP = 28;
/** Enough for "Brochettes de" in the 42px display face on one line. */
export const TITLE_MIN_WIDTH = 300;

export function actionsFitBesideTitle(contentWidth: number): boolean {
  return contentWidth - 2 * SIDE_PADDING - ROW_GAP - ACTIONS_WIDTH >= TITLE_MIN_WIDTH;
}
